var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-2 text-center",style:(_vm.sizeStyle),attrs:{"title":`${_vm.text}`,"img-src":`${_vm.assetUrl}${_vm.imgURL}`,"img-alt":`${_vm.text} image`,"img-top":"","tag":"article"},on:{"click":_vm.handleBlockClick}},[_c('b-card-text')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }